import React from "react";
import { useAuth } from "../auth/AuthContext";
import { Link } from "react-router-dom";
import { ShoppingCart, Download } from "lucide-react";
import { canSuggestPWAInstallation } from "../utils/usePWAInstall";
import { TrackButton } from "./TrackLink";

export const Navbar = (props: { installApp: Function }) => {
  const { user } = useAuth();

  if (!user) return null;

  return (
    <div className="bg-white border-b border-gray-200 py-3">
      <div className="container mx-auto px-4 flex justify-between items-center">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-600 rounded-lg">
            <ShoppingCart className="h-6 w-6 text-white" />
          </div>
          <h1 className="text-xl font-bold text-gray-900">MyMarket</h1>
        </div>

        <div className="flex items-center gap-3">
          {canSuggestPWAInstallation() && (
            <TrackButton
              event="navbar_install_app"
              onClick={() => props.installApp()}
              className="flex items-center gap-2 px-3 py-2 text-sm text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
              title="Instalar aplicativo"
            >
              <Download className="h-4 w-4" />
              <span className="hidden sm:inline">Instalar</span>
            </TrackButton>
          )}

          {user && (
            <>
              <div className="flex items-center">
                {user.picture && (
                  <img
                    src={user.picture}
                    alt={user.name}
                    className="w-8 h-8 rounded-full mr-2"
                  />
                )}
                <span className="text-sm hidden md:inline">{user.name}</span>
              </div>

              <Link
                to="/dash/logout"
                className="px-3 py-1 text-sm text-gray-700 hover:bg-gray-100 rounded"
              >
                Sair
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
